export * from '@taqueria/protocol/out/types/ProxyTemplateArgs';
